import {
    JobResponse,
    PublicJobResponse,
    SimpleJob,
    SimpleJobResponse
} from '../types/job';

import {
    convertJobResponseToJob,
    convertPublicJobResponseToPublicJob,
    convertSimpleJobResponseToSimpleJob,
    convertSimpleJobToSimpleJobResponse
} from './convert/job';
import { del, get, post, put } from './http';

export const getJob = (jobID: number) =>
    get(`/api/job/${jobID}`).then((response: JobResponse) =>
        convertJobResponseToJob(response)
    );

export const getPublicJob = (jobID: number) =>
    get(`/api/job/public/${jobID}`).then((response: PublicJobResponse) => {
        const job = convertPublicJobResponseToPublicJob(response);
        return job;
    });

export const createJob = (jobDict: SimpleJob) => {
    const jobResponse = convertSimpleJobToSimpleJobResponse(jobDict);
    return post('/api/job', jobResponse).then((response: SimpleJobResponse) =>
        convertSimpleJobResponseToSimpleJob(response)
    );
};

export const updateJob = (jobDict: SimpleJob) => {
    const jobResponse = convertSimpleJobToSimpleJobResponse(jobDict);
    return put('/api/job', jobResponse).then((response: SimpleJobResponse) =>
        convertSimpleJobResponseToSimpleJob(response)
    );
};

export const getUserJobs = (userID: number) =>
    get(`/api/job/user/${userID}`).then((response: JobResponse[]) =>
        response.map(convertJobResponseToJob)
    );

export const getCompanyJobs = (companyID: number) =>
    get(`/api/job/company/${companyID}`).then((response: JobResponse[]) =>
        response.map(convertJobResponseToJob)
    );

export const getJobsBySearch = (search: string) =>
    get(`/api/job/search/?search=${search}`);

export const addSavedJob = (userID: number, jobID: number) =>
    post(`/api/job/saved/${userID}/${jobID}`, {});

export const removeSavedJob = (userID: number, jobID: number) =>
    del(`/api/job/saved/${userID}/${jobID}`, {});

export const getSavedJobs = (userID: number) =>
    get(`/api/job/saved/${userID}`).then((response: JobResponse[]) =>
        response.map(convertJobResponseToJob)
    );
